const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4431 17.3808L20.9995 21.9371M18.75 11.812C18.75 16.1613 15.2242 19.687 10.875 19.687C6.52576 19.687 3 16.1613 3 11.812C3 7.46277 6.52576 3.93701 10.875 3.93701C15.2242 3.93701 18.75 7.46277 18.75 11.812Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
